import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Sparkles, Loader2 } from "lucide-react";

export default function Login() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    try {
      await login(username, password);
      navigate("/");
    } catch (err) {
      setError(
        err?.response?.data?.detail || err?.message || "Login failed",
      );
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#FAFAFA] flex items-center justify-center px-4">
      <div className="w-full max-w-sm">
        <div className="flex items-center gap-2 justify-center mb-8">
          <div className="w-8 h-8 bg-[#002FA7] flex items-center justify-center">
            <Sparkles size={18} className="text-white" />
          </div>
          <div>
            <div className="font-bold text-base tracking-tight leading-tight font-[Chivo]">
              PROCURE / CA
            </div>
            <div className="text-[10px] uppercase tracking-widest text-zinc-500 font-mono">
              RFP Intelligence
            </div>
          </div>
        </div>

        <form
          onSubmit={handleSubmit}
          className="bg-white border border-zinc-200 p-6 space-y-4"
        >
          <div>
            <label className="block text-xs uppercase tracking-widest text-zinc-500 font-mono mb-1.5">
              Username
            </label>
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              className="w-full border border-zinc-300 px-3 py-2 text-sm focus:outline-none focus:border-zinc-900 transition-colors"
              placeholder="admin"
              required
            />
          </div>

          <div>
            <label className="block text-xs uppercase tracking-widest text-zinc-500 font-mono mb-1.5">
              Password
            </label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full border border-zinc-300 px-3 py-2 text-sm focus:outline-none focus:border-zinc-900 transition-colors"
              placeholder="••••••"
              required
            />
          </div>

          {error && (
            <div className="text-red-600 text-xs font-mono">{error}</div>
          )}

          <button
            type="submit"
            disabled={submitting}
            className="w-full bg-[#002FA7] hover:bg-[#002175] text-white py-2 text-sm font-medium transition-colors disabled:opacity-50 flex items-center justify-center gap-2"
          >
            {submitting && <Loader2 size={14} className="animate-spin" />}
            {submitting ? "Signing in…" : "Sign In"}
          </button>
        </form>

        <div className="text-center mt-6">
          <div className="text-[10px] uppercase tracking-widest text-zinc-400 font-mono">
            v1.0 · Canada Only
          </div>
          <div className="text-xs text-zinc-500 mt-1">
            HR · Payroll · ERP · Oracle · SAP · K-12
          </div>
        </div>
      </div>
    </div>
  );
}
